
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/steelbuildingestimates/privacy-policy",
      function () {
        return require("private-next-pages/steelbuildingestimates/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/steelbuildingestimates/privacy-policy"])
      });
    }
  